import React, { Component } from 'react';
import { Navbar, Nav, NavbarBrand, NavbarText, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import Utils from "../../Utils";
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.getProfileData(this);
        this.state = {
            collapsed: true,
            profiledata: [],
            userInfo: { roles: "P" }
        };
        setTimeout(this.getUserInfo(), 800);

    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    async getProfileData() {
        let profileData = await Utils.getProfileData();
        this.setState({
            profiledata: profileData
        });
    }

    async getUserInfo() {
        await Utils.getUserInfo()
            .then(data => {
                let d = data.status;
                if (d === 200) {
                    this.setState({ userInfo: data.data });
                }
                else {
                    window.location.href = "/.auth/login";
                }
                if ((data.data.roles === 'A' || data.data.roles === 'V') &&
                    (window.location.href !== window.location.origin + "/admin"))
                    window.location.href = window.location.origin + "/admin";
            });
    }


    async logOut() {
        await Utils.logOut();
    }

    render() {
        return (
            <Navbar color="dark" container dark expand="md">
                <NavbarBrand href="/"> <img src="/logo-score-proveedores_2.svg" alt="logo-socre" width="274px" /></NavbarBrand>
                <NavbarText id="ultimaActualizacion" style={{ color:"#fff" }}> </NavbarText>
                <Nav className="ml-auto" navbar>
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                            <img src="/icon-user.svg" alt="usuario" width="26px" />
                        </DropdownToggle>
                        <DropdownMenu right>
                            {this.state.profiledata ?
                                <>
                                    <DropdownItem header>
                                        {this.state.profiledata.lastname} {this.state.profiledata.name}
                                    </DropdownItem>
                                    {this.state.userInfo.roles === "A" || this.state.userInfo.roles === "V" ?
                                        <DropdownItem><a href="/admin">Administrar</a></DropdownItem> : null
                                    }
                                    <DropdownItem onClick={() => this.logOut()}>
                                        <a href="#">Logout</a>
                                    </DropdownItem>
                                    
                                </>
                                :
                                <DropdownItem header>
                                    <a href="/.auth/login">Login</a>
                                </DropdownItem>
                            }
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Nav>
            </Navbar>
        );
    }
}